import { render, staticRenderFns, recyclableRender, components } from "./apply.vue?vue&type=template&id=2aa603d9&"
var renderjs
import script from "./apply.vue?vue&type=script&lang=js&"
export * from "./apply.vue?vue&type=script&lang=js&"
import style0 from "./apply.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages2/region/cash/apply/apply.vue"
export default component.exports